export default "__VITE_ASSET__Cl_RV9N9__"